import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
  ) {}

  private credentialsRequiredEndpoints: string[] = [
    // your endpoints
  ];

  private isCredentialsRequired(url: string): boolean {
    return this.credentialsRequiredEndpoints.some(endpoint => url.startsWith(endpoint) || url.includes(endpoint));
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();

    let updatedRequest = request;

    if (token) {
      updatedRequest = updatedRequest.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + '' + token)
      });
    }

    if (!updatedRequest?.headers.has('Content-Type')) {
      if (updatedRequest.headers.has('Content-Disposition')) {
        updatedRequest = updatedRequest.clone({
          headers: updatedRequest.headers.set('Content-Disposition', 'multipart/form-data')
        });
      } else {
        updatedRequest = updatedRequest.clone({
          headers: updatedRequest.headers.set('Accept', 'application/json')
        });
      }
    } else if (updatedRequest.headers.get('Content-Type') !== 'multipart/form-data') {
      updatedRequest = updatedRequest.clone({
        headers: updatedRequest.headers.set('Content-Type', 'application/json')
      });
    }

    if (this.isCredentialsRequired(request.url)) {
      updatedRequest = updatedRequest.clone({ withCredentials: true });
    } else {
      updatedRequest = updatedRequest.clone({ withCredentials: false });
    }

    if (updatedRequest.method === 'GET') {
      updatedRequest = updatedRequest.clone({
        headers: updatedRequest.headers
          .set('Cache-Control', 'no-cache, no-store, must-revalidate')
          .set('Pragma', 'no-cache')
          .set('Expires', '0')
      });
    }

    return next.handle(updatedRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // handle response if needed
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        const unauthorizedMessage = 'Unauthorized user Access. Invalid token';
        const newerSessionMessage = 'Session expired. A newer login session exists. Please log in again.';
        const responseMessage = (error?.error?.responseMessage || error?.error?.message || '').trim();
 
        if (
          error.status === 401 &&
          (responseMessage === unauthorizedMessage || responseMessage === newerSessionMessage)
        ) {
          this.authService.logout();
        }

        if (responseMessage === newerSessionMessage) {
          return throwError(() => new Error('Session expired. Please log in again.'));
        }

        if (error.status === 401) {
          return throwError(() => new Error('Unauthorized. Please check your credentials.'));
        }
        return throwError(() => error);
      })
    );
  }
}
